define('TescoMobile_DynamicBundleOptions/js/view/tenure-hint-modal',['uiComponent', 'jquery', 'Magento_Ui/js/modal/modal', 'mage/translate'], function (Component, $, modal, $t) {
  'use strict';

  return Component.extend({
    defaults: {
      tenureHintBlockContent: ''
    },
    setModalElement: function (element) {
      this.modalElement = element;
      var options = {
        type: 'slide',
        responsive: true,
        innerScroll: true,
        clickableOverlay: false,
        modalClass: 'without-header',
        buttons: [],
        trigger: "#tenure-hint"
      };
      modal(options, $(element));
    }
  });
});

